import TripListFilterMenuItem from './TripListFilterMenuItem'

interface Props {
  value: string
  label: string
  count: number
  selected: boolean
  onToggle: (value: string) => void
}

function LocationFilterMenuItem({ value, label, count, selected, onToggle }: Props) {
  return (
    <TripListFilterMenuItem
      value={value}
      label={label}
      count={count}
      selected={selected}
      onToggle={onToggle}
    />
  )
}

export default LocationFilterMenuItem
